import { Link } from "react-router";
import { useAuth } from "../auth/AuthProvider";
import { useBrandingSettings } from "../../lib/settings/useBrandingSettings";

type LogoProps = {
  collapsed?: boolean;
};

// Default logo paths (fallback if branding not loaded or not custom)
const DEFAULT_COLLAPSED_LOGO = "/uploads/brand/qb_logo_icon.svg";
const DEFAULT_FULL_LOGO = "/uploads/brand/qb_logo_textsvg-01.svg";

export const Logo = ({ collapsed }: LogoProps) => {
  const { appConfig } = useAuth();
  const { settings, loading } = useBrandingSettings();

  // Determine which logo to show based on collapsed state and branding settings
  const logoUrl = collapsed
    ? settings?.collapsedLogoUrl || DEFAULT_COLLAPSED_LOGO
    : settings?.fullLogoUrl || DEFAULT_FULL_LOGO;

  // Show nothing during initial load to prevent flicker
  if (loading && !settings) {
    return (
      <div className={collapsed ? "flex items-center justify-center" : "w-full"}>
        <div className={collapsed ? "h-8" : "w-full h-12"} />
      </div>
    );
  }

  return (
    <div className={collapsed ? "flex items-center justify-center" : "w-full"}>
      <Link to={appConfig?.defaultPage ?? "/profile"} className="block">
        <img
          src={logoUrl}
          alt="QuickBox Pro"
          className={collapsed ? "h-8" : "w-full h-12"}
        />
      </Link>
    </div>
  );
};
